import ISlideMaster from '@app/types/presentations/master/ISlideMaster';
import ICustomSlideData from '@app/types/data/slides/ICustomSlideData';
import ICloudinaryAsset from '@/libraries/src/cloudinary/ICloudinaryAsset';
import AbstractSlideTransform, { thumbnailCropOptions } from './AbstractSlideTransform';
import ICustomSlide from '../../types/presentations/presentation/ICustomSlide';

/**
 * Transform for 018-CustomSlide
 */
export default class CustomSlideTransform extends AbstractSlideTransform {
	public viewComponent: string = 'CustomSlide';

	public async transform(slide: ISlideMaster): Promise<ICustomSlideData> {
		const customSlide: ICustomSlide = slide as ICustomSlide;

		const data: ICustomSlideData = {
			id: customSlide.id,
			shareViewSection: 'special-info',
			label: customSlide.headline,
			thumbnail: this.transformImageAsset(customSlide.asset as ICloudinaryAsset, thumbnailCropOptions),
			headline: customSlide.headline,
			copy: `<p>${customSlide.copy.replace(/\n\n/g, '</p><p>').replace(/\n/g, '<br />')}</p>`,
			badgeText: customSlide.badgeText
		};

		if (customSlide.asset) {
			data.image = this.transformImageAsset(customSlide.asset, {
				width: 5000,
				height: 5000,
				crop: 'limit'
			});
		}

		return data;
	}
}
